import { createFileRoute } from '@tanstack/react-router';
import { EditWebhookPage } from '../components/pages/BusinessPage/Webhook/EditWebhookPage';

export const Route = createFileRoute('/account/business_/webhooks_/$webhookId')({
  component: EditWebhookPage,
});
